import { render, staticRenderFns } from "./preview-table.vue?vue&type=template&id=75ef060b&scoped=true&"
import script from "./preview-table.vue?vue&type=script&lang=ts&"
export * from "./preview-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ef060b",
  null
  
)

export default component.exports